module.exports = __webpack_public_path__ + "img/1920_stores_img2.1c3c1b9a.png";